import { Card } from "react-bootstrap"

const LastFileLoad = ({ data }: { data: any }) => {
  const fileLoadData = data?.["last-file-load"] ?? {}
  const lastLoadDate = fileLoadData.last_load_date
  const fileName = fileLoadData.file_name

  const formattedDate = lastLoadDate
    ? new Date(lastLoadDate).toLocaleDateString()
    : "N/A"

  return (
    <Card className="custom-card overflow-hidden h-100 border-0 mb-0">
      <Card.Body className="p-0 d-flex h-100 flex-column">
        <div className="p-3 pb-0">
          <span className="d-block fw-semibold fs-15">Last File Load</span>
        </div>
        <div className="p-3 pt-2 flex-grow-1 overflow-auto">
          <ul className="list-unstyled mb-0">
            <li className="d-flex justify-content-between align-items-center py-3 border-bottom">
              <span className="fs-13 text-truncate me-2">Load Date</span>
              <span className="fs-13 text-muted flex-shrink-0">{formattedDate}</span>
            </li>
            <li className="d-flex justify-content-between align-items-center py-3">
              <span className="fs-13 text-truncate me-2">File Name</span>
              <span className="fs-13 text-muted flex-shrink-0 text-end">{fileName || "N/A"}</span>
            </li>
          </ul>
        </div>
      </Card.Body>
    </Card>
  )
}

export default LastFileLoad
